@if (hasError) {
	<div class="hmf-text-align-center hmf-p-xl hmf-my-xxl">
		<my-account-components-error-state
			[description]="
				'Something unexpected happened on our end. Refresh or close this page to try again.'
			"></my-account-components-error-state>
		<hmf-button
			[variant]="'primary'"
			[text]="'TRY AGAIN'"
			[size]="'medium'"
			[label]="'Try Again'"
			(click)="window.location.reload()"
			class="hmf-mt-m"></hmf-button>
	</div>
} @else {
	<div class="hmf-text-align-center hmf-pt-xxl hmf-pb-xxxl">
		<homefield-icon
			name="arrow-loop-cw"
			width="44px"
			height="44px"></homefield-icon>
		<span class="hmf-header-bold-s hmf-display-block">Hang tight.</span>
		<span class="hmf-body-m hmf-display-block">You are being redirected to another page.</span>
	</div>
}
